(function () {
  'use strict';
  var controllerId = 'inoltraFerie';
  angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'richiesta', inoltraFerieFn]);

  function inoltraFerieFn($scope, $uibModalInstance, datacontext, richiesta) {
    $scope.richiesta = richiesta;

    $scope.cancel = function () {
        $uibModalInstance.close(null);
    };

    $scope.ok = function () {
      datacontext.richiestaFerie_inoltra($scope.richiesta).then(function (data) {
          $uibModalInstance.close(data);
      });     
    }
  }
})();
